import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

export default function index({ list }: any) {
    const { useState, useLang } = useGlobal();
    const { t } = useLang('landingPage');
    const [isShow, setIsShow] = useState(false);
    return (
        <div className={css.canPower}>
            <div className="title" onClick={() => setIsShow(() => !isShow)}>
                <div className="left-text">{t('secF_powerList')}</div>
                <div className={`right-svg ${isShow ? 'is-click' : ''}`}></div>
            </div>
            <div className={`content ${isShow ? 'show-content' : ''}`}>
                {list.map((item: any, k: number) => {
                    return (
                        <div className="power-item" key={k}>
                            <div className="icon">{item.icon}</div>
                            <div className="info">
                                <div className="name">{item.name}</div>
                                <div className="power">{item.times}</div>
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
}
